import { BREAKPOINTS } from '../utils/dom';

export const SCROLL_THRESHOLD = 20;
export const DROPDOWN_CLOSE_DELAY = 50;
export const FIXED_HEIGHT_DELAY = 500;

interface HeaderElements {
    body: HTMLElement;
    mobileSidebar: HTMLElement | null;
    navbar: HTMLElement | null;
    searchLandingPage: HTMLElement | null;
    navbarDropdowns: NodeListOf<HTMLElement> | null;
    content: HTMLElement | null;
    mpWrapper: HTMLElement | null;
}

export const elements: HeaderElements = {
    body: document.body,
    mobileSidebar: null,
    navbar: null,
    searchLandingPage: null,
    navbarDropdowns: null,
    content: null,
    mpWrapper: null
};

interface HeaderState {
    scrollTop: number;
    dropdownTimer: ReturnType<typeof setTimeout> | null;
    isMobileMenuOpen: boolean;
    isSearchOpen: boolean;
}

export const state: HeaderState = {
    scrollTop: 0,
    dropdownTimer: null,
    isMobileMenuOpen: false,
    isSearchOpen: false
};

export function initElements(): void {
    elements.mobileSidebar = document.getElementById('mobileSideBar');
    elements.navbar = document.querySelector('.mp-navbar');
    elements.searchLandingPage = document.querySelector('.search-landing-page');
    elements.navbarDropdowns = document.querySelectorAll('.mp-navbar-dropdown');
    elements.content = document.querySelector('.mp-content');
    elements.mpWrapper = document.querySelector('.mp-wrapper');
}

export function isDesktop(): boolean {
    return window.innerWidth >= BREAKPOINTS.lg;
}